import queryString from 'qs';

const getStockListRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.search) queries.search = queryParams?.search;
  if (queryParams?.brand) queries.brand = `[${queryParams?.brand?.map((brand) => brand.value).join(',')}]`;
  if (queryParams?.statusStock) queries.statusStock = queryParams?.statusStock?.value;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getStockListRequest;
